import {Card} from 'primereact/card';
import {Steps} from '../components/StepsComponent';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
// import Tooltip from 'tooltip-js';
import {v4 as uuidv4} from 'uuid';
import BaseContainer from '../baseContainers/BaseContainer';
import {ActionButton} from '../components/ActionButton';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import EditableDataTableExt from '../components/EditableDataTableExt';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import OrderFuelModel from '../model/OrderFuelModel';
import AccountService from '../services/AccountService';
import DriverService from '../services/DriverService';
import OrderFuelService from '../services/OrderFuelService';
import SettingService from '../services/SettingService';
import TrailerService from '../services/TrailerService';
import VehicleService from '../services/VehicleService';
import {AnwimLpgDeliveryContainer} from './AnwimLpgDeliveryContainer';
import {DriverContainer} from './DriverContainer';
import OrderFuelConfirmationDialog from './OrderFuelConfirmationDialog';
import {OrderFuelOrderTypeContainer} from './OrderFuelOrderTypeContainer';
import {OwnDeliveryContainer} from './OwnDeliveryContainer';
import {VehicleTrailerOrderFuel} from './VehicleTrailerOrderFuel';
//poprawić walidacje

class OrderFuelContainer extends BaseContainer {
    constructor(props) {
        super(props);
        const {t} = this.props;
        this.driverService = new DriverService();
        this.vehicleService = new VehicleService();
        this.trailerService = new TrailerService();
        this.service = new OrderFuelService();
        this.accountService = new AccountService();
        this.settingService = new SettingService();
        this.renderFirstPage = this.renderFirstPage.bind(this);
        this.renderSecondPage = this.renderSecondPage.bind(this);
        this.renderThirdPage = this.renderThirdPage.bind(this);
        this.renderFourthPage = this.renderFourthPage.bind(this);
        this.renderBackButton = this.renderBackButton.bind(this);
        this.renderNextButton = this.renderNextButton.bind(this);
        this.renderStepsNav = this.renderStepsNav.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAddFuel = this.handleAddFuel.bind(this);
        this.calculatePrice = this.calculatePrice.bind(this);
        this.user = this.authService.getProfile();
        this.countQuantity = this.countQuantity.bind(this);
        this.countVolume = this.countVolume.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleShowTooltipMenuItem = this.handleShowTooltipMenuItem.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
        this.fetchDrivers = this.fetchDrivers.bind(this);
        this.onAfterTransportTypeChange = this.onAfterTransportTypeChange.bind(this);
        this.onAfterPurposeChange = this.onAfterPurposeChange.bind(this);
        this.fetchVehicles = this.fetchVehicles.bind(this);
        this.fetchTrailers = this.fetchTrailers.bind(this);
        this.fetchFuels = this.fetchFuels.bind(this);
        this.handleSelectAnwimDelivery = this.handleSelectAnwimDelivery.bind(this);
        this.handleOwnDeliverySelect = this.handleOwnDeliverySelect.bind(this);
        this.handleAdblueLpgSelect = this.handleAdblueLpgSelect.bind(this);
        this.onTooltipClick = this.onTooltipClick.bind(this);
        this.crossFieldValidation = this.crossFieldValidation.bind(this);

        this.state = {
            pageIndex: this.props.templateEdit ? 2 : 1,
            maxFuelCards: 5,
            checkAll: undefined,
            pbMaxCount: 0,
            pbMinCount: 0,
            onMinCount: 0,
            onMaxCount: 0,
            orderTypeOptions: [
                {enumValue: 'ANWIM_DELIVERY', label: t('OrderType.ANWIM_DELIVERY')},
                {enumValue: 'OWN_DELIVERY', label: t('OrderType.OWN_DELIVERY')},
                {enumValue: 'LPG_ADBLUE', label: t('OrderType.LPG_ADBLUE')},
            ],
            ownDeliverPurposeTypeOpt: [
                {enumValue: 'OWN_STATION', label: t('PurposeType.OWN_STATION')},
                {enumValue: 'RESALE', label: t('PurposeType.RESALE')},
                {enumValue: 'NO_SENT_TRX', label: t('PurposeType.NO_SENT_TRX')},
            ],
            element: props.element
                ? OrderFuelModel.copy(props.element, props.t)
                : {
                      anwimDelivery: true,
                      ownDelivery: false,
                      adBlueLpg: false,
                      orderType: 'ANWIM_DELIVERY',
                      fuels: [],
                      draft: false,
                  },
            balance: {},
            amount: props.amount ? props.amount : 0,
            driverOpt: [],
            vehicleOpt: [],
            trailerOpt: [],
            fuelsOpt: [],
            confirmationDialogVisibile: false,
            sentNumberTooltipVisibile: false,
            confirmationDialogInfo: false,
            financialAuth: {
                attachment: undefined,
                orderId: undefined,
            },
        };
    }

    fetchVehicles() {
        const {t} = this.props;
        this.vehicleService
            .getList(this.state.element.transportType ? {own: this.state.element.transportType === 'OWN'} : {})
            .then((res) => {
                let result = res?.content;
                if(result !== null && result !== undefined) {
                result.forEach(r =>{
                    let wholeNameValue = `${r?.registrationNumber} (${!!r?.own ? t('trailer.own-true') : t('trailer.own-false')})`;
                    r['wholeName'] = wholeNameValue;
                })
                }
                this.setState({vehicleOpt: result}, () => {
                    let found = false;
                    res.content.forEach((el) => {
                        if (this.state.element?.vehicle?.sapId === el.sapId) {
                            found = true;
                        }
                    });
                    if (!found) {
                        this.setState((prevState) => ({
                            ...prevState,
                            element: {
                                ...prevState.element,
                                vehicle: undefined,
                            },
                        }));
                    }
                });
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.vehicleListError'));
            });
    }

    fetchTrailers() {
        const {t} = this.props;
        this.trailerService
            .getList(this.state.element.transportType ? {own: this.state.element.transportType === 'OWN'} : {})
            .then((res) => {
                let result = res?.content;
                if(result !== null && result !== undefined) {
                    result.forEach(r =>{
                        let wholeNameValue = `${r?.registrationNumber} (${t(`EcTrailerType.${r?.type}`)}, ${ !!r?.own ? t('trailer.own-true') : t('trailer.own-false') })`;
                        r['wholeName'] = wholeNameValue;
                    })
                    }
                this.setState({trailerOpt: result}, () => {
                    let found = false;
                    res.content.forEach((el) => {
                        if (this.state.element?.trailer?.sapId === el.sapId) {
                            found = true;
                        }
                    });
                    if (!found) {
                        this.setState((prevState) => ({
                            ...prevState,
                            element: {
                                ...prevState.element,
                                trailer: undefined,
                            },
                        }));
                    }
                });
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.trailerListError'));
            });
    }

    onAfterTransportTypeChange() {
        this.setState(
            (prevState) => ({
                element: {
                    ...prevState.element,
                    driver: undefined,
                    vehicle: undefined,
                    trailer: undefined,
                    carrierEmail: '',
                },
            }),
            () => {
                this.fetchDrivers();
                this.fetchVehicles();
                this.fetchTrailers();
            }
        );
    }

    onAfterPurposeChange() {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                sentNumber: '',
                partner: undefined,
            },
        }));
    }

    componentDidMount() {
        super.componentDidMount();
        this.blockUi();
        this.initBeforeSetElement();
        this.setElement();
    }

    initAfterSetElement() {
        this.fetchDrivers();
        this.fetchVehicles();
        this.fetchTrailers();
        this.accountService
            .getBalance()
            .then((balance) => {
                let remainingA = balance.remainingLimit;
                if (this.props.element) {
                    remainingA = balance.remainingLimit - this.props.amount;
                }
                this.setState({balance, remainingAmount: remainingA}, () => {
                    this.calculatePrice();
                    this.unblockUi();
                });
            })
            .catch(() => {
                this.unblockUi();
                const {t} = this.props;
                this.showErrorMessage(t('error.getBalanceError'));
            });

        this.fetchFuels();
    }

    initBeforeSetElement() {
        const {t} = this.props;
        this.settingService
            .getFuelRanges()
            .then((resp) =>
                this.setState({
                    pbMinCount: resp['MIN_PB'],
                    pbMaxCount: resp['MAX_PB'],
                    onMinCount: resp['MIN_ON'],
                    onMaxCount: resp['MAX_ON'],
                })
            )
            .catch((err) => this.showErrorMessage(t('error.getFuelRangesError')));
        this.settingService.getValue('DEBT_COLLECTION_PHONE_NUMBER').then((resp) =>
            this.setState({
                phoneNumber: resp.value,
            })
        );
        this.service
            .getDeliveryPlaces()
            .then((res) => {
                this.setState({deliveryPlaces: res});
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.deliveryPlacesError'));
            });
        this.service
            .getFuelBases()
            .then((res) => {
                this.setState({fuelBases: res});
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.fuelBasesError'));
            });
    }

    setElement() {
        const {t} = this.props;
        if (this.props.elementId) {
            this.service
                .get(this.props.elementId)
                .then((data) => {
                    const el = OrderFuelModel.copy(data, t);
                    if (data.werks && this.state.fuelBases) {
                        let found = false;
                        this.state.fuelBases.forEach((el) => {
                            if (el.sapId === data.werks.sapId) {
                                found = true;
                            }
                        });
                        if (!found) {
                            data.werks = undefined;
                        }
                    }
                    if (data.partner && this.state.deliveryPlaces) {
                        let found = false;
                        this.state.deliveryPlaces.forEach((el) => {
                            if (el.sapId === data.partner.sapId) {
                                found = true;
                            }
                        });
                        if (!found) {
                            data.partner = undefined;
                        }
                    }
                    el.draft = false;
                    this.setState({loading: false, element: el, pageIndex: 2}, () => this.initAfterSetElement());
                })
                .catch((err) => {
                    this.showErrorMessage(t('error.getOrderCardTemplateError'));
                    window.location.href = this.props.backUrl;
                });
        } else {
            this.initAfterSetElement();
        }
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    getContainerListName() {
        return 'draft-list-container';
    }

    handleSelectAnwimDelivery() {
        this.setState(
            (prevState) => ({
                element: {
                    anwimDelivery: true,
                    ownDelivery: false,
                    adBlueLpg: false,
                    fuels: [],
                    orderType: 'ANWIM_DELIVERY',
                },
            }),
            () => this.fetchFuels()
        );
    }

    handleOwnDeliverySelect() {
        this.setState(
            (prevState) => ({
                element: {
                    anwimDelivery: false,
                    ownDelivery: true,
                    adBlueLpg: false,
                    fuels: [],
                    orderType: 'OWN_DELIVERY',
                },
            }),
            () => this.fetchFuels()
        );
    }

    handleAdblueLpgSelect() {
        this.setState(
            (prevState) => ({
                element: {
                    anwimDelivery: false,
                    ownDelivery: false,
                    adBlueLpg: true,
                    fuels: [],
                    orderType: 'LPG_ADBLUE',
                },
            }),
            () => this.fetchFuels()
        );
    }

    renderFirstPage() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className='header'>{`1. ${t('order-fuel.orderType')}`} </div>
                </DivContainer>
                <OrderFuelOrderTypeContainer
                    t={this.props.t}
                    element={this.state.element}
                    handleAnwimSelect={this.handleSelectAnwimDelivery}
                    handleOwnDeliverySelect={this.handleOwnDeliverySelect}
                    handleAdblueLpgSelect={this.handleAdblueLpgSelect}
                />
                <div className='row footer-buttons'>
                    {this.renderBackButton(1)}
                    {this.renderNextButton(2)}
                </div>
            </React.Fragment>
        );
    }

    renderDriver() {
        return (
            <DriverContainer
                t={this.props.t}
                element={this.state.element}
                validator={this.validator}
                handleChange={this.handleChange}
                driverOpt={this.state.driverOpt}
            />
        );
    }

    renderNotesSummary() {
        return (
            <InputTextComponent
                id='remarks'
                name='remarks'
                label={''}
                showLabel={false}
                colClass='col-12'
                viewMode={'EDIT'}
                onChange={this.handleChange}
                value={this.state.element.remarks}
            />
        );
    }

    renderPetrolsSummary() {
        const {t} = this.props;
        return (
            <React.Fragment>
                {this.state.element.fuels && this.state.element.fuels.length
                    ? this.state.element.fuels.map((fuel, index) => {
                          const backgroundColor = fuel?.fuel?.color ? fuel.fuel.color : '#090E22';
                          return (
                              <React.Fragment key={`name-${fuel.name ? fuel.name : index}`}>
                                  <div className='row'>
                                      <InputTextComponent
                                          id='fuel-summary'
                                          name='fuel'
                                          label={t('order-fuel.fuels')}
                                          colClass='col-12 margin-bottom-8'
                                          viewMode={'VIEW'}
                                          showLabel={index === 0}
                                          onChange={this.props.handleChange}
                                          value={fuel.name}
                                          renderValue={() => {
                                              return fuel ? (
                                                  <React.Fragment>
                                                      <label
                                                          className='black-labels flex-inputs'
                                                          style={{backgroundColor: backgroundColor}}
                                                      >
                                                          {t(`products.${fuel?.fuel?.name}`)}
                                                      </label>
                                                      <label className='white-labels flex-inputs'>
                                                          {fuel.quantity} m3 ({fuel.volume} l)
                                                      </label>
                                                  </React.Fragment>
                                              ) : (
                                                  <label />
                                              );
                                          }}
                                      />
                                  </div>
                              </React.Fragment>
                          );
                      })
                    : null}
                <DivContainer colClass='row right-summary'>
                    <div className='flex-inputs'>
                        <label className='font-14-400 right '>{t('order-fuel.estimatedValue')}:</label>
                        <span className='font-14-600-right font-blue margin-left-8'>
                            <NumberFormat
                                value={this.state.amount}
                                displayType={'text'}
                                thousandSeparator=' '
                                decimalSeparator=','
                                fixedDecimalScale
                                decimalScale={2}
                                suffix={` ${t('currency.pln')}`}
                                renderText={(value, props) => value}
                            />
                        </span>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }

    renderDriverVehicleSummary() {
        const {t} = this.props;
        return (
            <div className='row'>
                <div className='col-lg-4 col-md-6 col-sm-12'>
                    <InputTextComponent
                        id='driver-summary'
                        name='driver'
                        label={t('order-fuel.driver')}
                        colClass='col-12'
                        value={this.state.element.driver}
                        renderValue={() => {
                            return this.state.element.driver ? (
                                <React.Fragment>
                                    <label className='black-labels flex-inputs'>{`${this.state.element.driver.firstName} ${this.state.element.driver.lastName}`}</label>
                                    <label className='white-labels flex-inputs'>PESEL: {this.state.element.driver.pesel}</label>
                                    <label className='white-labels flex-inputs'>
                                        {t('order-fuel.docNumber')}: {this.state.element.driver.documentNumber}
                                    </label>
                                </React.Fragment>
                            ) : (
                                <label />
                            );
                        }}
                        viewMode={'VIEW'}
                    />
                </div>
                <div className='col-md-4 col-sm-12'>
                    <InputTextComponent
                        id='vehicle-summary'
                        name='vehicle'
                        label={t('order-fuel.vehicle')}
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        value={this.state.element.vehicle}
                        renderValue={() => {
                            return this.state.element.vehicle && this.state.element.vehicle?.registrationNumber ? (
                                <React.Fragment>
                                    <label className='black-labels flex-inputs'>{this.state.element.vehicle.registrationNumber}</label>
                                    <label className='white-labels flex-inputs'>
                                        {!!this.state.element.vehicle?.own
                                            ? t('order-fuel.vehicle-own-true')
                                            : t('order-fuel.vehicle-own-false')}
                                    </label>
                                </React.Fragment>
                            ) : (
                                <label />
                            );
                        }}
                        viewMode={'VIEW'}
                    />
                </div>
                <div className='col-md-4 col-sm-12'>
                    <InputTextComponent
                        id='trailer-summary'
                        name='trailer'
                        label={t('order-fuel.trailer')}
                        colClass='col-lg-6 col-md-12 col-sm-12'
                        value={this.state.element.trailer}
                        renderValue={() => {
                            return this.state.element.trailer &&
                                this.state.element.trailer?.registrationNumber &&
                                this.state.element.trailer?.type ? (
                                <React.Fragment>
                                    <label className='black-labels flex-inputs'>{this.state.element.trailer.registrationNumber}</label>
                                    <label className='white-labels flex-inputs'>
                                        {t(`EcTrailerType.${this.state.element.trailer.type}`)}
                                    </label>
                                    <label className='white-labels flex-inputs'>
                                        {!!this.state.element.trailer?.own
                                            ? t('order-fuel.trailer-own-true')
                                            : t('order-fuel.trailer-own-false')}
                                    </label>
                                </React.Fragment>
                            ) : (
                                <label />
                            );
                        }}
                        viewMode={'VIEW'}
                    />
                </div>
            </div>
        );
    }

    renderSecondPage() {
        const {t} = this.props;
        return (
            <DivContainer colClass='row'>
                <div className='header'>{`2. ${t('order-fuel.delivery')}`}</div>
                {!!this.state.element.anwimDelivery || !!this.state.element.adBlueLpg ? (
                    this.renderAnwimDeliveryOrLpgAdBlue2or4PageFragment()
                ) : !!this.state.element.ownDelivery ? (
                    <React.Fragment>
                        {this.renderOwnDeliverySummary()}
                        {this.renderDriver()}
                        <React.Fragment>
                            {this.state.element.transportType ? (
                                <VehicleTrailerOrderFuel
                                    t={this.props.t}
                                    element={this.state.element}
                                    handleChange={this.handleChange}
                                    validator={this.validator}
                                    vehicleOpt={this.state.vehicleOpt}
                                    trailerOpt={this.state.trailerOpt}
                                    filterByWholeName={true}
                                />
                            ) : null}
                            <div className='row'>
                                <InputTextComponent
                                    id='carrierEmail'
                                    name='carrierEmail'
                                    label={t('order-fuel.carrierEmail')}
                                    colClass='col-md-8 col-sm-12'
                                    value={this.state.element.carrierEmail}
                                    viewMode={'EDIT'}
                                    validator={this.validator}
                                    validators='required|email'
                                    onChange={this.handleChange}
                                    rendered={
                                        this.state.element?.purpose !== 'NO_SENT_TRX' && this.state.element.transportType === 'RENTED'
                                    }
                                />
                            </div>
                        </React.Fragment>
                    </React.Fragment>
                ) : null}

                <div className='row footer-buttons'>
                    {this.renderBackButton(1)}
                    {this.renderNextButton(3)}
                </div>
            </DivContainer>
        );
    }

    onTooltipClick() {
        if (!!this.state.sentNumberTooltipVisibile) {
            this.setState({sentNumberTooltipVisibile: false});
        } else {
            this.setState({sentNumberTooltipVisibile: true});
        }
    }

    renderOwnDeliverySummary(summary) {
        return (
            <OwnDeliveryContainer
                agreementEmail={this.user.agreementEmail}
                carrierEmail={this.state.element.carrierEmail}
                deliveryPlaces={this.state.deliveryPlaces}
                t={this.props.t}
                summary={summary}
                element={this.state.element}
                validator={this.validator}
                handleChange={this.handleChange}
                orderTypeOptions={this.state.orderTypeOptions}
                ownDeliverPurposeTypeOpt={this.state.ownDeliverPurposeTypeOpt}
                fuelBases={this.state.fuelBases}
                onAfterTransportTypeChange={this.onAfterTransportTypeChange}
                onAfterPurposeChange={this.onAfterPurposeChange}
                handleHideTooltip={this.handleHideTooltip}
                handleShowTooltip={this.handleShowTooltip}
                handleShowTooltipMenuItem={(this, this.handleShowTooltipMenuItem)}
                onTooltipClick={this.onTooltipClick}
                sentNumberTooltipVisibile={this.state.sentNumberTooltipVisibile}
                dialogMode={true}
                templateEdit={this.props.templateEdit}
            />
        );
    }

    renderAnwimDeliveryOrLpgAdBlue2or4PageFragment(summaryPage) {
        return (
            <AnwimLpgDeliveryContainer
                t={this.props.t}
                summaryPage={summaryPage}
                element={this.state.element}
                validator={this.validator}
                agreementEmail={this.user.agreementEmail}
                deliveryPlaces={this.state.deliveryPlaces}
                handleChange={this.handleChange}
                orderTypeOptions={this.state.orderTypeOptions}
                handleHideTooltip={this.handleHideTooltip}
                handleShowTooltip={this.handleShowTooltip}
                handleShowTooltipMenuItem={(this, this.handleShowTooltipMenuItem)}
                onTooltipClick={this.onTooltipClick}
                sentNumberTooltipVisibile={this.state.sentNumberTooltipVisibile}
                templateEdit={this.props.templateEdit}
            />
        );
    }

    fetchFuels() {
        const {t} = this.props;
        const type = !!this.state.element.ownDelivery ? 'FCA' : 'DDP';
        const adblueLpg = !!this.state.element.adBlueLpg;
        this.blockUi();
        this.service
            .getFuels(type, adblueLpg, !!this.state.element.anwimDelivery, !!this.state.element.ownDelivery)
            .then((res) => {
                res.forEach((r) => {
                    r.label = t(`products.${r.name}`);
                });
                this.setState({fuelsOpt: res}, () => {
                    let fuelsList = this.state.element.fuels;
                    let availableFuelIds = [];
                    res.forEach((el) => {
                        availableFuelIds.push(el.sapId);
                    });
                    if (fuelsList && fuelsList.length > 0) {
                        let i = fuelsList.length;
                        while (i--) {
                            if (!availableFuelIds.includes(fuelsList[i].fuel.sapId)) {
                                fuelsList.splice(i, 1);
                            }
                        }
                        let newIn = 1;
                        fuelsList.forEach((el) => {
                            el.lp = newIn;
                            newIn++;
                        });
                        this.calculatePrice();
                    }
                    this.setState((prevState) => ({
                        ...prevState,
                        element: {
                            ...prevState.element,
                            fuels: fuelsList,
                        },
                    }));
                    this.unblockUi();
                });
            })
            .catch((err) => {
                this.unblockUi();
                this.showErrorMessage(t('error.fuelOptionsError'));
            });
    }

    fetchDrivers() {
        const {t} = this.props;
        this.blockUi();
        this.driverService
            .getList(this.state.element.transportType ? {own: this.state.element.transportType === 'OWN'} : {})
            .then((res) =>
                this.setState({driverOpt: res?.content}, () => {
                    let found = false;
                    res.content.forEach((el) => {
                        if (this.state.element?.driver?.sapId === el.sapId) {
                            found = true;
                        }
                    });
                    if (!found) {
                        this.setState((prevState) => ({
                            ...prevState,
                            element: {
                                ...prevState.element,
                                driver: undefined,
                            },
                        }));
                    }
                    this.unblockUi();
                })
            )
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.driverListError'));
            });
    }

    handleAddFuel() {
        const modifiedList = this.state.element.fuels;
        modifiedList.push({fuel: undefined, volume: undefined, quantity: undefined, uuid: uuidv4(), lp: modifiedList.length + 1});
        this.setState((prevState) => ({
            ...prevState,
            element: {
                ...prevState.element,
                fuels: modifiedList,
            },
        }));
    }

    crossFieldValidation(field, rowData) {
        if (rowData !== undefined && field === 'quantity') {
            if (rowData?.fuel?.incoterms === 'FCA') {
                if (rowData?.fuel?.pb === true) {
                    return `required|number_min_float:0.001|number_max_float:${this.state.pbMaxCount}`;
                } else if (rowData?.fuel?.on === true) {
                    return `required|number_min_float:0.001|number_max_float:${this.state.onMaxCount}`;
                }
            } else if (rowData?.fuel?.incoterms === 'DDP') {
                if (rowData?.fuel?.pb === true) {
                    return `required|number_min_float:${this.state.pbMinCount}|number_max_float:${this.state.pbMaxCount}`;
                } else if (rowData?.fuel?.on === true) {
                    return `required|number_min_float:${this.state.onMinCount}|number_max_float:${this.state.onMaxCount}`;
                } else {
                     return `required|number_min_float:0.001`;
                }
            }
        } else {
            return undefined;
        }
    }

    renderThirdPage() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='header'>
                    <div className='row summary-row'>
                        <div className='left-part col-lg-6 col-sm-12'>
                            <div className='flex-container'>
                                <label id='list-title' className='list-title'>{`3. ${t('order-fuel.fuels')}`}</label>
                                <div className=''>
                                    <ActionButton
                                        label={t('order-fuel.addButton')}
                                        variant={'white'}
                                        iconSvg='ico_white_plus'
                                        iconSide='left'
                                        colClass=''
                                        className=''
                                        handleClick={this.handleAddFuel}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='right-summary col-lg-6 col-sm-12'>
                            <label className='font-14-400 right flex-inputs '>{t('order-fuel.remainingLimit')}:</label>
                            <span className='font-14-600-right margin-left-8'>
                                <NumberFormat
                                    value={this.state.remainingAmount}
                                    displayType={'text'}
                                    thousandSeparator=' '
                                    decimalSeparator=','
                                    fixedDecimalScale
                                    decimalScale={2}
                                    suffix={` ${t('currency.pln')}`}
                                    renderText={(value, props) => value}
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <DivContainer colClass='row'>
                    <EditableDataTableExt
                        // messages={this.messages}
                        id={`fuels-edition`}
                        name='fuels'
                        showLabel={false}
                        label={t('order-fuel.fuels')}
                        breakpoint={'10px'}
                        crossFieldValidation={this.crossFieldValidation}
                        columns={[
                            {
                                field: 'lp',
                                header: 'Lp.',
                                editable: () => false,
                                editor: 'LP',
                            },
                            // ile minimum
                            {
                                field: 'fuel',
                                header: t('order-fuel.ware'),
                                editor: 'DROPDOWN',
                                optionLabel: 'label',
                                dataKey: 'sapId',
                                options: this.state.fuelsOpt,
                                editable: true,
                                validators: 'required',
                            },
                            {
                                field: 'quantity',
                                header: t('order-fuel.quantity'),
                                editor: 'NUMBER',
                                maxFractionDigits: 3,
                                editable: true,
                                validators: 'required',
                                afterEditCol: this.countVolume,
                            },
                            {
                                field: 'volume',
                                header: t('order-fuel.volume'),
                                editor: 'NUMBER',
                                editable: true,
                                validators: 'required',
                                afterEditCol: this.countQuantity,
                            },
                        ]}
                        addedListName='addedList'
                        addedList={this.state.addedList}
                        modifiedListName='modifiedList'
                        modifiedList={this.state.modifiedList}
                        validator={this.validator}
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        createNewElement={() => {}}
                        editable
                        showAddButton={false}
                        showDeleteButton
                        stateField={'element'}
                        dataKey='uuid'
                        //updateItemElementAfterEdit={this.updateItemElementAfterEdit}
                        ref={this.editableListRef}
                        className='col-lg-8 col-md-8 col-sm-12 min-width-content'
                        tableClassName='order-fuels-table'
                        value={this.state.element.fuels}
                        publicMode
                        validators='array_required'
                        permanentDelete
                        onAfterEditElement={this.calculatePrice}
                        deleteButtonClassName='float-left pi pi-trash no-underline'
                        showDeleteButtonLabel={false}
                        onAfterRemoveElement={this.calculatePrice}
                        handleTranslate={this.translate}
                    />
                </DivContainer>
                <DivContainer colClass='row right-summary'>
                    <div className='flex-inputs'>
                        <label className='font-14-400 right '>{t('order-fuel.estimatedValue')}:</label>
                        <span className='font-14-600-right font-blue margin-left-8'>
                            <NumberFormat
                                value={this.state.amount}
                                displayType={'text'}
                                thousandSeparator=' '
                                decimalSeparator=','
                                fixedDecimalScale
                                decimalScale={2}
                                suffix={` ${t('currency.pln')}`}
                                renderText={(value, props) => value}
                            />
                        </span>
                    </div>
                </DivContainer>
                <div className='row footer-buttons'>
                    {this.renderBackButton(2)}
                    {this.renderNextButton(4)}
                </div>
            </React.Fragment>
        );
    }

    calculatePrice() {
        const {t} = this.props;
        if (this.state.element.fuels) {
            this.calculate(this.state.element.fuels)
                .then((res) => {
                    this.setState(
                        (prevState) => ({
                            remainingAmount: res.balance,
                            amount: res.amount,
                        }),
                        () => this.unblockUi()
                    );
                })
                .catch((err) => {
                    this.showErrorMessage(t('error.errorCalculateFuelPrice'));
                    this.unblockUi();
                });
        }
    }

    calculate(list) {
        let sum = 0;
        const balance = this.state?.balance?.remainingLimit;
        list.forEach((f) => {
            if (!!f.quantity && !!f.volume)
                switch (f?.fuel?.unitTypeIso) {
                    case 'M15':
                        sum += f?.fuel?.price * f.quantity;
                        break;
                    case 'LTR':
                        sum += f?.fuel?.price * f.volume;
                        break;
                    default:
                        break;
                }
        });

        return Promise.resolve({amount: sum, balance: balance - sum});
    }

    renderFourthPage() {
        const {t, templateEdit} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className='header'>{`4. ${t('details.summary')}`}</div>
                    <React.Fragment>
                        <DivContainer colClass='dashboard'>
                            <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-order-fuel '>
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-12'>
                                        <Card>
                                            {!!this.state.element.anwimDelivery || !!this.state.element.adBlueLpg
                                                ? this.renderAnwimDeliveryOrLpgAdBlue2or4PageFragment(true)
                                                : this.renderOwnDeliverySummary(true)}
                                        </Card>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                        {!this.state.element.anwimDelivery && !this.state.element.adBlueLpg ? (
                            <DivContainer colClass='dashboard'>
                                <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-profile '>
                                    <DivContainer colClass='row'>
                                        <DivContainer colClass='col-12'>
                                            <Card>{this.renderDriverVehicleSummary()}</Card>
                                        </DivContainer>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        ) : null}
                        <DivContainer colClass='dashboard'>
                            <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-profile '>
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-12'>
                                        <Card>{this.renderPetrolsSummary()}</Card>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </React.Fragment>
                    <div className='header header-notes'>{t('order-fuel.notes')}</div>
                    <DivContainer colClass='dashboard'>
                        <DivContainer colClass='col-12 dashboard-link-container dashboard-link-container-profile '>
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <Card>{this.renderNotesSummary()}</Card>
                                </DivContainer>
                            </DivContainer>
                        </DivContainer>
                    </DivContainer>
                    <DivContainer colClass='row'>
                        <InputCheckboxComponent
                            id={`draft`}
                            name='draft'
                            label={templateEdit ? t('order-fuel.saveAsNewDraft') : t('order-fuel.saveAsDraft')}
                            labelOnRight
                            value={this.state.element.draft}
                            validator={this.validator}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            validators='not_required'
                            colClass='col-12 big-checkbox'
                        />
                        <InputTextComponent
                            id='draftName'
                            name='draftName'
                            label={''}
                            showLabel={false}
                            colClass='col-md-6 col-sm-12'
                            value={this.state.element.draftName}
                            placeholder={t('order-fuel.nameYourDraft')}
                            viewMode={'EDIT'}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            rendered={!!this.state?.element?.draft}
                        />
                    </DivContainer>
                </DivContainer>
                <div className='row footer-buttons'>
                    {this.renderBackButton(3)}
                    {this.renderNextButton(5)}
                </div>
            </React.Fragment>
        );
    }

    renderBackButton(pageNumber) {
        const {t} = this.props;
        return (
            <ActionButton
                label={t('details.back')}
                variant={this.state.pageIndex === 5 ? 'back-button blue' : 'back-button white m'}
                colClass=''
                href={(this.state.pageIndex === 1 || this.state.pageIndex === 5) && !this.props.handleBack ? '/#/orders' : null}
                handleClick={
                    this.state.pageIndex !== 1 && this.state.pageIndex !== 5
                        ? (e) => {
                              e.preventDefault();
                              this.setState({pageIndex: pageNumber});
                              this.scrollToTop();
                          }
                        : this.props.handleBack
                        ? this.props.handleBack
                        : null
                }
            />
        );
    }

    renderNextButton(pageNumber) {
        const {t, templateEdit} = this.props;
        let label;
        switch (this.state.pageIndex) {
            case 1:
                label = `${t('details.forward')} - ${t('order-fuel.delivery_low')}`;
                break;
            case 2:
                label = `${t('details.forward')} - ${t('order-fuel.fuels_low')}`;
                break;
            case 3:
                label = `${t('details.forward')} - ${t('autoRegistration.summary')}`;
                break;
            case 4:
                label = templateEdit ? t('details.saveChanges') : t('autoRegistration.placeOrder');
                break;
            case 5:
                label = t('order-fuel.orderFinalButton');
                break;
            default:
                label = t('details.forward');
                break;
        }
        return (
            <ActionButton
                label={label}
                variant='next-button blue m'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.handleFormSubmit(e, pageNumber);
                }}
            />
        );
    }

    parseDeliveryDate(){
        const {element} = this.state;
        if (!element.deliveryDate) return;
        const dateAtStartOfDay = new Date(element.deliveryDate);
        dateAtStartOfDay.setHours(0, 0, 0, 0);
        element.deliveryDate = dateAtStartOfDay;
    }

    createOrUpdate() {
        const {t} = this.props;
        const {element} = this.state;
        this.parseDeliveryDate();
        this.scrollToTop();
        if (this._isMounted) {
            this.blockUi();
            if (this.props.templateEdit) {
                if (this.state.element.draft) {
                    this.setState({petraId: undefined}, () => {
                        this.service
                            .updateTemplate(element)
                            .then(() => {
                                this.afterTemplateEdit(true);
                            })
                            .catch(() => {
                                this.afterTemplateEdit();
                            });
                    });
                } else {
                    this.service
                        .updateTemplate(element)
                        .then(() => {
                            this.afterTemplateEdit(true);
                        })
                        .catch(() => {
                            this.afterTemplateEdit();
                        });
                }
            } else {
                this.service
                    .orderFuel(element)
                    .then((response) => {
                        this.unblockUi();
                        if (response.status === 'PRODUCT_ERROR') {
                            this.showErrorMessage(t('order-fuel.error.PRODUCT_ERROR'));
                        } else if (response.status === 'ERROR') {
                            if (!!response.sapErrorMessageList && response.sapErrorMessageList.length > 0) {
                                response.sapErrorMessageList.forEach((key) => this.showErrorMessage(t(`order-fuel.error.${key}`)));
                            } else {
                                this.showErrorMessage(t('error.addOrderFuelError'));
                            }
                        } else {
                            this.setState({orderFuelResponse: response, confirmationDialogVisibile: true});
                        }
                    })
                    .catch((err) => {
                        this.unblockUi();
                        this.showErrorMessage(t('error.addOrderFuelError'));
                    });
            }
        }
    }

    afterTemplateEdit(success) {
        const {t} = this.props;
        if (success) {
            this.persistMessage('success', '', t('order-fuel.successUpdateTemplate'));
        } else {
            this.persistMessage('error', '', t('error.editTemplateError'));
        }
        this.unblockUi();
        window.location.href = this.props.backUrl;
    }

    handleFormSubmit(event, pageNumber) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.validator.hideMessages();
            if (pageNumber !== 5) {
                this.blockUi(this.setState({pageIndex: pageNumber}, () => this.unblockUi()));
                this.scrollToTop();
            } else {
                this.createOrUpdate();
            }
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderStepsNav() {
        const {t} = this.props;
        const items = [
            {label: t('order-fuel.orderType')},
            {label: t('order-fuel.delivery')},
            {label: t('order-fuel.fuels')},
            {label: t('details.summary')},
        ];
        return (
            <div className='col-md-8 col-sm-12'>
                <Steps
                    model={items}
                    activeIndex={this.state.pageIndex - 1}
                    icons
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    nextIconsSrc='/images/ico_steps_next.svg'
                />
            </div>
        );
    }

    render() {
        return (
            <DivContainer colClass='container-fluid order-fuel'>
                <DivContainer colClass=''>
                    <BlockUi
                        tag='div'
                        blocking={this.state.blocking || this.state.loading}
                        loader={this.loader}
                        rendered={!this.props.embedded}
                    >
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                        {!!this.state.orderFuelResponse ? (
                            <OrderFuelConfirmationDialog
                                className='order-fuel-confirmation-dialog'
                                visible={this.state.confirmationDialogVisibile}
                                onHide={() => {}}
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                status={this.state.orderFuelResponse?.status}
                                orderNumber={this.state.orderFuelResponse?.orderNumber}
                                phoneNumber={this.state.phoneNumber}
                                backUrl={this.props.backUrl}
                                showMessage={this.showMessage}
                                embedded
                                _isMounted={this._isMounted}
                            />
                        ) : null}
                        <DivContainer colClass=''>{this.state.loading ? null : this.renderCard()}</DivContainer>
                    </BlockUi>
                </DivContainer>
            </DivContainer>
        );
    }

    renderCard() {
        return (
            <Card className='details-card' footer={this.renderFooter()}>
                <form onSubmit={this.handleFormSubmit} noValidate>
                    {this.renderDetails()}
                </form>
            </Card>
        );
    }

    renderDetails() {
        const {t, templateEdit} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='container-fluid'>
                        <div className='order-fuel'>
                            <div>
                                <div>
                                    <div className='order-fuel-header'>
                                        <div className='header-flex'>
                                            <div className='title'>
                                                {templateEdit
                                                    ? `${t('order-card.editTemplateHeader')}: ${
                                                          this.state.element.draftName ? this.state.element.draftName : ''
                                                      }`
                                                    : t('order-fuel.newTitle')}
                                            </div>
                                            <ActionButton
                                                className='back-button'
                                                label={t('order-fuel.cancelOrdering')}
                                                variant={'white'}
                                                iconColor='blue'
                                                href={this.props.backUrl}
                                            />
                                        </div>
                                        <div>{this.renderStepsNav()}</div>
                                    </div>

                                    {this.state.pageIndex === 1 ? this.renderFirstPage() : null}
                                    {this.state.pageIndex === 2 ? this.renderSecondPage() : null}
                                    {this.state.pageIndex === 3 ? this.renderThirdPage() : null}
                                    {this.state.pageIndex === 4 ? this.renderFourthPage() : null}
                                    {this.state.pageIndex === 5 ? this.renderFinalPage() : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    countQuantity(rowData, event) {
        this.handleChange(
            'EDITABLE_DATA_TABLE',
            ['EDIT', rowData, 'uuid', 'NUMBER', undefined, {name: 'quantity', value: !isNaN(event?.value) ? 0.001 * event.value : 0}],
            {name: 'fuels'},
            this.calculatePrice,
            'element'
        );
    }

    countVolume(rowData, event) {
        this.handleChange(
            'EDITABLE_DATA_TABLE',
            ['EDIT', rowData, 'uuid', 'NUMBER', undefined, {name: 'volume', value: !isNaN(event?.value) ? 1000 * event.value : 0}],
            {name: 'fuels'},
            this.calculatePrice,
            'element'
        );
    }

    handleShowTooltip() {
        this.setState({sentNumberTooltipVisibile: true});
    }

    handleHideTooltip() {
        this.setState({sentNumberTooltipVisibile: false});
    }

    handleShowTooltipMenuItem() {
        this.setState({sentNumberTooltipVisibile: true});
    }
}

OrderFuelContainer.defaultProps = {
    backUrl: '/#/orders',
    element: undefined,
};

OrderFuelContainer.propTypes = {
    backUrl: PropTypes.string,
    element: PropTypes.object,
    handleBack: PropTypes.func,
};

export default withTranslation()(OrderFuelContainer);
